"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCR = function FlagCR(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "92.8",
    width: "409.6",
    height: "84.74",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06V-76.1H-193v-38.84a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "46.91",
    width: "409.6",
    height: "45.91",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V100.45H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "177.55",
    width: "409.6",
    height: "45.91",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.26,12.18c0,19.5-14.79,35.31-33,35.31s-33-15.81-33-35.31,14.79-35.31,33-35.31,33,15.81,33,35.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "94.62",
    y: "121.52",
    width: "34.17",
    height: "17.09",
    fill: "#3cc8ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.81,8.23l.38,3.77,1.54-3.47-.79,3.71,2.53-2.83-1.91,3.29,3.29-1.9-2.82,2.53,3.7-.8-3.46,1.54,3.77.39-3.77.39,3.46,1.53-3.7-.79,2.82,2.53-3.29-1.9,1.91,3.28-2.53-2.82.79,3.7-1.54-3.46-.38,3.77-.39-3.77-1.54,3.46.79-3.7-2.53,2.82,1.9-3.28-3.28,1.9L-97,15.59l-3.7.79,3.46-1.53-3.77-.39,3.77-.39-3.46-1.54,3.7.8-2.82-2.53,3.28,1.9-1.9-3.29,2.53,2.83-.79-3.71L-95.2,12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-75.45,39.52H-89.12l-12.53-10.25V14.46h39.87V29.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.62,9.9a.57.57,0,0,0-.57-.56.56.56,0,0,0-.56.56h0a13.05,13.05,0,0,1-2.55,6.67,15.52,15.52,0,0,1-3-7.16,1.28,1.28,0,0,0-1.84-.95,1.29,1.29,0,0,0-.69,1c-.88,5.59-3.51,8-5.22,8.94-2.55-2.47-3.39-6.46-3.67-8.82a1.33,1.33,0,0,0-1.92-1,1.36,1.36,0,0,0-.66.79,17.13,17.13,0,0,1-13.5,12v3.42h39.87V19c-4.56-1.14-5.7-9.12-5.7-9.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.92-.35c-4.56-2.28-4.56-4.56-4.56-4.56s-5.69-2.27-10.25-2.27c0,0,1.14-2.28-1.14-2.28H-85.7c-2.28,0-1.14,2.28-1.14,2.28-4.56,0-10.25,2.27-10.25,2.27s0,2.28-4.56,4.56-4.55,7.4-4.55,7.4a1.7,1.7,0,0,0,1.7,1.71,1.7,1.7,0,0,0,1.71-1.71,1.72,1.72,0,0,0-.1-.55l.1,0,11.39-8h18.23l11.39,8,.1,0a1.72,1.72,0,0,0-.1.55,1.7,1.7,0,0,0,1.71,1.71,1.71,1.71,0,0,0,1.71-1.71s0-5.12-4.56-7.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f0aa00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.5,13.32c-1.14,0-4.56,0-4.56-3.42s4.56-3.42,4.56-3.42l-6.84-2.27c-2.28,8,2.28,8,2.28,18.22,0,9.18-10.25,14.81-13.67,14.81a4.94,4.94,0,0,0-4.56,2.28,4.91,4.91,0,0,0-4.55-2.28c-3.42,0-13.67-5.63-13.67-14.81,0-10.25,4.56-10.25,2.28-18.22l-6.84,2.27s4.56,0,4.56,3.42-3.42,3.42-4.56,3.42-5.69,0-5.69,5.7,5.69,12.52,13.67,17.08,4.55,9.11,14.8,9.11,6.84-4.55,14.81-9.11S-53.81,24.71-53.81,19s-4.56-5.7-5.69-5.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#f0aa00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-84.56-4.51l-2.76-1.24a2.34,2.34,0,0,0-1.45-.14A18.29,18.29,0,0,0-98.23-.35L-94.82.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80-4.51l2.76-1.24a2.33,2.33,0,0,1,1.45-.14A18.29,18.29,0,0,1-66.34-.35L-69.75.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-81.88-3.77l2.07-2.07a.3.3,0,0,0,0-.41.28.28,0,0,0-.4,0l-2.08,2.08-2.07-2.08a.3.3,0,0,0-.41,0,.3.3,0,0,0,0,.41l2.08,2.07-2.08,2.08a.28.28,0,0,0,0,.4.29.29,0,0,0,.21.09.28.28,0,0,0,.2-.09l2.07-2.07,2.08,2.07A.29.29,0,0,0-80-1.2a.25.25,0,0,0,.19-.09.27.27,0,0,0,0-.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.5,6.48c0-1.93-1.84-2.77-3.42-3.14v-.9c-2.15-.2-3.34-1-5.42-2.42-.8-.55-1.71-1.16-2.81-1.83-4-2.43-7.08-2.78-8.86-2.7v1.88h-4.55V-4.51c-1.78-.08-4.86.27-8.86,2.7-1.1.67-2,1.28-2.81,1.83-2.08,1.42-3.27,2.22-5.42,2.42v.9c-1.58.37-3.42,1.21-3.42,3.14l3.42-1.13v.52c3.24-.24,5.08-1.48,7.34-3,.77-.52,1.64-1.11,2.66-1.73a13.81,13.81,0,0,1,6-2.18V.79h6.83V-1.07a13.81,13.81,0,0,1,6,2.18c1,.62,1.89,1.21,2.65,1.73,2.27,1.55,4.12,2.79,7.35,3V5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.62-11.47v-1.41h-3.17a2.21,2.21,0,0,0,.89-1.71c0-3.14-7.16-4-11.39-4s-11.39.84-11.39,4a2.22,2.22,0,0,0,.9,1.71h-3.17v1.41a17.12,17.12,0,0,0-5.19,2.2l1.26,1.9a13.28,13.28,0,0,1,6.2-2.09V-10.6H-70.9v1.14a13.17,13.17,0,0,1,6.21,2.09l1.26-1.9a17.12,17.12,0,0,0-5.19-2.2Zm-9.11-1.73v-.86a.85.85,0,0,0-1.06-.83l-3.5.87-3.49-.87a.85.85,0,0,0-1.06.83v.86c-2.56-.37-4.07-1-4.48-1.39.61-.58,3.63-1.71,9-1.71s8.43,1.13,9,1.71c-.41.39-1.92,1-4.48,1.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#3cc8ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-82.14,1.22l.28.87h.92a.12.12,0,0,1,.07.22l-.73.55.27.87a.12.12,0,0,1-.19.13l-.74-.53-.74.53a.12.12,0,0,1-.19-.13l.28-.87-.74-.55a.12.12,0,0,1,.07-.22h.92l.28-.87a.13.13,0,0,1,.24,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-86.61,1.51l.38.83.91-.09a.12.12,0,0,1,.09.21l-.67.62.36.84a.12.12,0,0,1-.17.15l-.79-.44-.68.6a.13.13,0,0,1-.21-.12l.19-.89L-88,2.76a.12.12,0,0,1,0-.23l.9-.1.2-.89a.12.12,0,0,1,.23,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-91.2,2.73l.55.73.87-.28a.12.12,0,0,1,.14.18l-.52.75.53.74a.12.12,0,0,1-.13.19l-.87-.27-.54.74a.12.12,0,0,1-.22-.07l0-.91-.86-.28a.12.12,0,0,1,0-.23l.86-.3V2.8a.12.12,0,0,1,.21-.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.79,4.67l.64.65.82-.39a.12.12,0,0,1,.17.16l-.43.81.64.66a.13.13,0,0,1-.11.21L-95,6.62l-.43.8a.12.12,0,0,1-.23,0l-.13-.9-.9-.16a.12.12,0,0,1,0-.23l.81-.41L-96,4.77a.12.12,0,0,1,.21-.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-77.91,1.51l-.38.83-.91-.09a.12.12,0,0,0-.09.21l.67.62-.36.84a.12.12,0,0,0,.17.15l.79-.44.68.6a.13.13,0,0,0,.21-.12l-.18-.89.78-.46a.12.12,0,0,0,0-.23l-.9-.1-.2-.89a.12.12,0,0,0-.23,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-73.32,2.73l-.56.73-.86-.28a.12.12,0,0,0-.14.18l.52.75-.54.74a.13.13,0,0,0,.14.19l.87-.27.54.74a.12.12,0,0,0,.22-.07l0-.91.86-.28a.12.12,0,0,0,0-.23l-.87-.3V2.8a.12.12,0,0,0-.21-.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.73,4.67l-.64.65-.82-.39a.12.12,0,0,0-.17.16l.43.81-.63.66a.12.12,0,0,0,.1.21l.9-.15.44.8a.12.12,0,0,0,.23,0l.13-.9.9-.16a.12.12,0,0,0,0-.23l-.82-.41.12-.91a.12.12,0,0,0-.21-.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-90.15,28.55l5.8,3.88h7l3.24-2.77-2.49,1h-8.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-86.2,23.55l-.56,5.65-2.55-1a17.23,17.23,0,0,1,3.11-4.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "112.82",
    y: "144.31",
    width: "0.38",
    height: "9.61",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "116.31",
    y: "145.13",
    width: "0.38",
    height: "8.8",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "109.36",
    y: "145.13",
    width: "0.38",
    height: "8.8",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-79.83,30h-2.3a.44.44,0,0,1-.44-.43V28.42a.44.44,0,0,1,.44-.44h2.3a.44.44,0,0,1,.43.44v1.16a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-79.83,27.31h-2.3a.44.44,0,0,1-.44-.43V25.71a.44.44,0,0,1,.44-.43h2.3a.43.43,0,0,1,.43.43v1.17a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-79.83,24.82h-2.3a.44.44,0,0,1-.44-.44V23.22a.44.44,0,0,1,.44-.43h2.3a.43.43,0,0,1,.43.43v1.16a.44.44,0,0,1-.43.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.56,30h-1.87a.44.44,0,0,1-.44-.43V28.42a.44.44,0,0,1,.44-.44h1.87a.44.44,0,0,1,.43.44v1.16a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.56,27.52h-1.87a.44.44,0,0,1-.44-.43v-.84a.44.44,0,0,1,.44-.44h1.87a.43.43,0,0,1,.43.44v.84a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.56,25.05h-1.87a.44.44,0,0,1-.44-.43v-.57a.44.44,0,0,1,.44-.43h1.87a.43.43,0,0,1,.43.43v.57a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.52,30H-85.4a.43.43,0,0,1-.43-.43V28.42A.44.44,0,0,1-85.4,28h1.88a.44.44,0,0,1,.43.44v1.16a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.52,27.52H-85.4a.43.43,0,0,1-.43-.43v-.84a.44.44,0,0,1,.43-.44h1.88a.43.43,0,0,1,.43.44v.84a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.52,25.05H-85.4a.43.43,0,0,1-.43-.43v-.57a.43.43,0,0,1,.43-.43h1.88a.43.43,0,0,1,.43.43v.57a.43.43,0,0,1-.43.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-84.27,22.13v1.13l1.68-.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-77.31,22.13v1.13l1.67-.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.8,21.3v1.15l1.68-.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-85.25,13.62l2,1.35h2.44l1.12-1-.87.35H-83.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.87,11.88l-.2,2-.88-.34a5.86,5.86,0,0,1,1.08-1.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "111.87",
    y: "134.1",
    width: "0.13",
    height: "3.34",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "113.08",
    y: "134.39",
    width: "0.13",
    height: "3.06",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "110.66",
    y: "134.39",
    width: "0.13",
    height: "3.06",
    fill: "#8c5a28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-81.66,14.12h-.8a.15.15,0,0,1-.15-.14v-.41a.15.15,0,0,1,.15-.15h.8a.15.15,0,0,1,.15.15V14a.15.15,0,0,1-.15.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-81.66,13.19h-.8a.15.15,0,0,1-.15-.15v-.41a.15.15,0,0,1,.15-.15h.8a.15.15,0,0,1,.15.15V13a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-81.66,12.32h-.8a.15.15,0,0,1-.15-.15v-.4a.15.15,0,0,1,.15-.15h.8a.15.15,0,0,1,.15.15v.4a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.52,14.12h-.66a.14.14,0,0,1-.14-.14v-.41a.15.15,0,0,1,.14-.15h.66a.15.15,0,0,1,.15.15V14a.15.15,0,0,1-.15.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.52,13.26h-.66a.14.14,0,0,1-.14-.15v-.29a.14.14,0,0,1,.14-.15h.66a.15.15,0,0,1,.15.15v.29a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.52,12.4h-.66a.14.14,0,0,1-.14-.15v-.2a.15.15,0,0,1,.14-.15h.66a.15.15,0,0,1,.15.15v.2a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-82.94,14.12h-.65a.14.14,0,0,1-.15-.14v-.41a.15.15,0,0,1,.15-.15h.65a.15.15,0,0,1,.15.15V14a.15.15,0,0,1-.15.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-82.94,13.26h-.65a.14.14,0,0,1-.15-.15v-.29a.14.14,0,0,1,.15-.15h.65a.15.15,0,0,1,.15.15v.29a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-82.94,12.4h-.65a.14.14,0,0,1-.15-.15v-.2a.15.15,0,0,1,.15-.15h.65a.15.15,0,0,1,.15.15v.2a.15.15,0,0,1-.15.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.2,11.39v.39l.58-.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.79,11.39v.39l.59-.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-82,11.1v.4l.59-.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-86.67,7.62h-1.48a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1.48a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-75.43,7.62h-1a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-68.5,9.08h-.86a.55.55,0,0,1-.56-.55V8.44a.56.56,0,0,1,.56-.56h.86a.56.56,0,0,1,.55.56v.09a.55.55,0,0,1-.55.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCR;
exports["default"] = _default;